module.exports = __webpack_public_path__ + "img/0005.3b1668b5.gif";